<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large" style="width: 1200px;">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}
        <a class="button is-success is-pulled-right" @click="newContact">
          New Contact
        </a>
        </p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control">
          <label class="label">Contacts</label>
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <th>Type</th>
                <th>Phone</th>
                <th>Extension</th>
                <th>E-Mail</th>
                <th>Responsible</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-if="contacts.length > 0">
                <tr v-for="contact in contacts">
                  <td>{{parseType(contact.type, contact.other)}}</td>
                  <td><a :href="'tel:' + contact.phone">{{contact.phone}}</a></td>
                  <td>{{contact.phone_extension}}</td>
                  <td><a :href="'mailto:' + contact.email">{{contact.email}}</a></td>
                  <td>{{contact.responsible}}</td>
                  <td style="text-align: center;">
                    <a class="button button-table is-small" @click="excludeContact(contact.id)" v-if="parseInt(context.$store.state.config.user.level) === 3">
                      <i class="fa fa-trash"></i>
                    </a>
                    <a class="button button-table is-small" @click="editContact(contact.id)" v-if="parseInt(context.$store.state.config.user.level) <= 3 || parseInt(contact.type) === 4">
                      <i class="fa fa-pencil"></i>
                    </a>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="7" style="text-align: center;">No contacts</td>
                </tr>
              </template>
            </tbody>
          </table>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import Contact from './contact'
  import message from '../../utils/message'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      chain_id: {
        type: Number
      },
      provider_id: {
        type: Number
      },
      agency_id: {
        type: Number
      },
      hotel_id: {
        type: Number
      },
      edit: {
        type: Boolean
      }
    },
    data () {
      return {
        contacts: [],
        inProgress: false,
        stage: 1,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      excludeContact (id) {
        if (window.confirm('You are sure exclude contact?')) {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/contacts/exclude/' + id).then((response) => {
            let propsData = {
              title: 'Success',
              message: 'The contact was successfully removed',
              type: 'success',
              direction: 'down',
              duration: 4500,
              showCloseButton: true
            }
            message.openMessage(propsData)
            this.loadData()
          }, (response) => {
          })
        }
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      },
      newContact () {
        let propsData = {
          context: this.context,
          parent: this,
          chain_id: this.chain_id,
          provider_id: this.provider_id,
          agency_id: this.agency_id,
          hotel_id: this.hotel_id,
          title: 'New Contact',
          callback: 'loadData',
          edit: false
        }
        Contact.openContact(propsData)
      },
      editContact (id) {
        let propsData = {
          context: this.context,
          parent: this,
          id: id,
          title: 'Edit Contact',
          callback: 'loadData',
          edit: true
        }
        Contact.openContact(propsData)
      },
      loadData () {
        let url = ''
        let id = null
        if (this.chain_id) {
          url = '/contacts/chain/'
          id = this.chain_id
        } else if (this.provider_id) {
          url = '/contacts/provider/'
          id = this.provider_id
        } else if (this.agency_id) {
          url = '/contacts/agency/'
          id = this.agency_id
        } else if (this.hotel_id) {
          url = '/contacts/hotel/'
          id = this.hotel_id
        }
        this.context.$http.get(this.context.$store.state.config.apiURL + url + id).then((response) => {
          this.contacts = response.body
          document.body.appendChild(this.$el)
        }, (response) => {

        })
      },
      parseType (content, label) {
        let type = ''
        switch (parseInt(content)) {
          case 1:
            type = 'Commecial Representative'
            break
          case 2:
            type = 'Immediate Responsible'
            break
          case 3:
            type = 'Financial Officer'
            break
          case 4:
            if ((label !== '') && (label !== null)) {
              type = label
            } else {
              type = 'Other'
            }
            break
          case 5:
            type = 'Emergency'
            break
          case 6:
            type = 'General'
            break
          case 7:
            type = 'General Responsible'
            break
          case 8:
            type = 'Parent Company'
            break
          case 9:
            type = 'Contact Payment'
            break
          case 10:
            type = 'Commercial'
            break
          case 11:
            type = 'Operation'
            break
          default:
            break
        }
        return type
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .modal-card-body {
    min-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// Contacts.vue?643ad68b